export enum NewEventPageActions {
  invites,
}
